import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate, useNavigate, useLocation } from "react-router-dom";
import './App.css';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import Header from "./pages/common/Header";
import Login from "./pages/customer/Login";
import AdminLayout from "./pages/admin/Layout";
import CustomerLayout from "./pages/customer/Layout";
import ProductList from "./pages/customer/ProductList";
import CategoryList from "./pages/customer/CategoryList";
import POS from "./pages/admin/POS";
import ProductManagement from "./pages/admin/ProductManagement";
import Signup from "./pages/customer/Signup";
import MyPage from "./pages/customer/MyPage";
import SalesManagement from "./pages/admin/SalesManagement";
import MemberInfo from "./pages/admin/MemberInfo";

function App() {
  const [user, setUser] = useState(() => {
    try {
      const storedUser = localStorage.getItem("user");
      return storedUser ? JSON.parse(storedUser) : null;
    } catch (error) {
      return null;
    }
  });

  useEffect(() => {
    if (user) {
      localStorage.setItem("user", JSON.stringify(user));
    } else {
      localStorage.removeItem("user");
      localStorage.removeItem("token");
      localStorage.removeItem("selected_store_id");
    }
  }, [user]);

  return (
    <Router>
      <AppContent user={user} setUser={setUser} />
      {/* 토스트가 쌓이면 그 아래 POS 상단(카테고리 탭)을 가려 클릭을 먹는다. 항상 최신 하나만 띄운다. */}
      <ToastContainer limit={1} />
    </Router>
  );
}

function AppContent({ user, setUser }) {
  const navigate = useNavigate();
  const location = useLocation();
  const isAdminScreen =
    location.pathname === "/admin" || location.pathname.startsWith("/admin/");

  // useEffect(() => {
  //   if (user?.user?.role === "admin") {
  //     // console.log("🔥 Admin 감지, /admin/pos로 이동 시도");
  //     navigate("/admin/pos", { replace: true });
  //   } else if (user?.user?.role === "customer") {
  //     // console.log("🔥 Customer 감지, /로 이동 시도");
  //     navigate("/", { replace: true });
  //   } else {
  //   }
  // }, [user, navigate]);

  return (
    <>
      {/* 고객 화면에서는 로그인 여부·역할과 무관하게 헤더를 보여준다.
          (Header가 관리자면 '관리자' 버튼을, 아니면 로그인/마이페이지를 표시한다)
          관리자 화면은 자체 사이드바 레이아웃이므로 헤더를 붙이지 않는다. */}
      {!isAdminScreen && <Header user={user} setUser={setUser} />}
      <Routes>
        <Route
          path="/"
          element={<CategoryList />} // 비로그인 시 기본 경로로 CategoryList
          setUser={setUser}
        />
        <Route path="/products" element={<ProductList />} />
        <Route path="/login" element={<Login setUser={setUser} />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/mypage" element={<MyPage setUser={setUser} />} />

        <Route
          path="/admin/*"
          element={
            user?.user?.role === "admin" ? (
              <AdminLayout user={user} setUser={setUser} />
            ) : (
              <Navigate to="/" replace />
            )
          }
        >
          <Route index element={<Navigate to="/admin/pos" replace />} />
          <Route path="pos" element={<POS />} />
          <Route path="products" element={<ProductManagement admin={user?.user} />} />
          <Route path="sales" element={<SalesManagement admin={user?.user} />} />
          <Route path="members" element={<MemberInfo />} />
        </Route>

        <Route
          path="/customer/*"
          element={
            user?.user?.role === "customer" ? (
              <CustomerLayout user={user} setUser={setUser} />
            ) : (
              <Navigate to="/" replace />
            )
          }
        >
          <Route index element={<ProductList />} />
        </Route>
      </Routes>
    </>
  );
}

export default App;